import React from "react";

/**
 * Renders a node's server-provided icon (a raw SVG path string plus view box and stroke
 * attributes). Admin-only data from our own endpoint, so the path is trusted here.
 */
export const NodeIcon = ({ icon, size = 16, color = "currentColor", style }) => {
  if (!icon) return null;

  return (
    <svg
      viewBox={icon.view_box ?? "0 0 24 24"}
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth={icon.stroke_width ?? 2}
      strokeLinecap={icon.stroke_linecap ?? "round"}
      strokeLinejoin={icon.stroke_linejoin ?? "round"}
      style={{ flexShrink: 0, ...style }}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: icon.svg ?? "" }}
    />
  );
};

export default NodeIcon;
